// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"lW","reco":"mW","products":"nW"};